export const CONTACT_FORM_MAILING = 1
export const CONTACT_FORM_HR = 2
export const CONTACT_FORM_CLIENT = 3
export const CONTACT_FORM_PROJECT = 4
export const CONTACT_FORM_ACADEMY = 5



// WEBPACK FOOTER //
// ./src/constants/contactFormServices.js